import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from 'src/tenantConfig/interface';
import { mcapsHelpPMFilterConfig } from './filters/mcapsHelpPMFilterConfig';
export const MCAPSHelpTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.McapsHelpPMNode],
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: mcapsHelpPMFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: mcapsHelpPMFilterConfig,
      AreaPath: [UATConstants.MCAPSHelpPM_DefaultValue_AreaPath],
      Title: UATConstants.TenantTitles.McapsHelpPM,
      ADOTitle: UATConstants.TenantADOText.McapsHelpPM,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateMCAPSHelpRequest,
          Key: UATConstants.CreateActionMenuKey.CreateMCAPSHelpRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {},
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'requestors', formFieldLabel: UATConstants.PlaceholdersAndTitles.ProblemRequestors, apiFieldName: 'requestorsinfo' },
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'stakeholders', formFieldLabel: UATConstants.PlaceholdersAndTitles.Stakeholders, apiFieldName: 'stakeholdersinfo' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: '1652c7fd-b110-4d57-a2c4-d37f9a88ec58',
      sharedViewsFolderId: 'ca88a915-0bdf-4ea7-a29b-e356972f8703',
    },
  },
};
